import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PagesDetailsPage from "./PagesDetailsPage";
import PagesListingPage from "./PagesListingPage";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";

export default function PagesManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          PagesListingPage,
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/:pageId`}
        component={withPermission(
          PagesDetailsPage,
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR, Roles.HKNT_VIEWER],
          [Roles.SUPERADMIN, Roles.HKNT_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
